import React from 'react';
import { Button } from 'geniebook-ui/dist';
import { useSetAtom, useAtomValue } from 'jotai';
import {
  errorAtom,
  successAtom,
} from '@components/subscription/store/SubscriptionAtoms';
import {
  hintAddOnQueryAtom,
  updateRenewalAtom,
} from '@components/subscription/store/HintPaymentAtoms';
import { Player } from '@lottiefiles/react-lottie-player';
import button_loading from '@assets/animation/loading-dots.json';

const ReactivateHintButton = () => {
  const setSuccess = useSetAtom(successAtom);
  const setError = useSetAtom(errorAtom);
  const updateMutation = useAtomValue(updateRenewalAtom);
  const hintDetailQuery = useAtomValue(hintAddOnQueryAtom);

  async function handleReactivateHint() {
    if (updateMutation.isPending || hintDetailQuery.isLoading) {
      return;
    }

    const { data } = await updateMutation.mutateAsync(true);

    if (data.error) {
      setError(data.error_msg);
    } else {
      await hintDetailQuery.refetch();
      setSuccess('Hooray! You can use unlimited hints for another year.');
    }
  }

  return (
    <Button
      className={
        'w-full !max-w-full !font-extrabold hover:transform hover:!scale-[1.01]'
      }
      onClick={handleReactivateHint}
    >
      {updateMutation.isPending || hintDetailQuery.isLoading ? (
        <Player
          autoplay={true}
          src={button_loading}
          loop={true}
          style={{ height: '32px' }}
        />
      ) : (
        'Reactivate subscription'
      )}
    </Button>
  );
};

export default ReactivateHintButton;
